export default __webpack_public_path__ + "static/media/soundon.15e9fb6a.svg";